module.exports = __webpack_public_path__ + "static/media/vencimiento_rojo.fa91bbdc.svg";